<div class="bg-white px-5 py-4 shadow-(--shadow-input) rounded-2xl mb-4 transition relative {{ customClass }}"
  [ngClass]="{
    'focus-within:ring-1 focus-within:ring-blue-500': !showError && !control?.disabled,
    'ring-1 ring-(--color-error)': showError,
    'opacity-30 cursor-auto': control?.disabled 
  }">
  <label class="block font-medium text-base" [attr.for]="inputId" [attr.lang]="lang" [ngClass]="{
    'text-(--text-secondary)': !showError,
    'text-(--color-error)': showError,
    'cursor-auto': control?.disabled   
  }">
    {{ label | translate }} <span *ngIf="showWarningIcon" class="inline-flex ml-1 w-4 h-4"><img src="assets/icons/warning.svg" alt="warning icon"/></span>

    <span *ngIf="!isRequired" class="text-(--text-muted)" [attr.lang]="forceLang"
      [attr.dir]="forceLang === 'ar' ? 'rtl' : 'ltr'">
      <ng-container *ngIf="forceLang">
        ({{ forceLang === 'ar' ? 'خياري' : 'Optional' }})
      </ng-container>

      <ng-container *ngIf="!forceLang">
        ({{ 'LOGIN.OPTIONAL' | translate }})
      </ng-container>
    </span>
  </label>

  <div class="flex gap-2 items-center">
    <p *ngIf="isMobile" class="text-generic order-1" dir="ltr">+962</p>
    <input [type]="type" [placeholder]="placeholder" [formControl]="control!" [id]="inputId"
      class="input-field placeholder:text-(--text-placeholder) w-3/4 order-2 rtl:order-1" [ngClass]="{
        ' ': isMobile,
        'w-full' : !isMobile
      }" />
  </div>

  <img *ngIf="isMobile" src="assets/icons/jordan-flag.svg" alt="jordan-flag"
    class="w-5 h-5 absolute top-1/2 -translate-y-1/2 ltr:right-5 rtl:left-5" />
</div>

<!-- Error Message -->
<p *ngIf="showError" class="text-(--color-error) text-sm mt-0 font-medium mb-4">
  {{ computedErrorMessage }}
</p>